export const STORES = [
    {
        id: "1",
        name: "Costco Wholesale Anchorage Warehouse",
        address: "330 W DIMOND BLVD, ANCHORAGE, AK 99515-1903",
        addressUrl: "https://maps.app.goo.gl/jbomYj21ZirUg4x3A",
        state: "AK",
        coordinates: [-149.88455283282963, 61.14355007774034],
    },
    {
        id: "2",
        name: "Costco Wholesale Fairbanks Warehouse",
        address: "48 COLLEGE RD, FAIRBANKS, AK 99701-1706",
        addressUrl: "https://maps.app.goo.gl/vA41g2ssQtFypxA28",
        state: "AK",
        coordinates: [-147.70834853007386, 64.85301826479795],
    },
    {
        id: "3",
        name: "Costco Wholesale NE Anchorage Warehouse",
        address: "4125 DEBARR RD, ANCHORAGE, AK 99508-3115",
        addressUrl: "https://maps.app.goo.gl/ALd8He4vupJ4jKFU6",
        state: "AK",
        coordinates: [-149.8048195077065, 61.21098695767406],
    },
    {
        id: "4",
        name: "Costco Wholesale Juneau Warehouse",
        address: "5225 COMMERCIAL BLVD, JUNEAU, AK 99801-7210",
        addressUrl: "https://maps.app.goo.gl/gPRqY4Uv8J8NX37C6",
        state: "AK",
        coordinates: [-134.48310473510662, 58.358990880218386],
    },
    {
        id: "5",
        name: "Costco Wholesale Caguas Warehouse",
        address: "200 AVE RAFAEL CORDERO, PR#30, CAGUAS BAIROA WARD, PR 00725-4302",
        addressUrl: "https://maps.app.goo.gl/7JfdbD73f2PCRU7F9",
        state: "PR",
        coordinates: [-66.02350795802619, 18.247637971697472],
    },
    {
        id: "6",
        name: "Costco Wholesale Carolina Warehouse",
        address: "1185 AVE 65 INFANTERIA, SAN JUAN, PR 00924-3403",
        addressUrl: "https://maps.app.goo.gl/7dN67Mpdhmy8aHbq7",
        state: "PR",
        coordinates: [-65.99787689203667, 18.400107548343787],
    },
    {
        id: "7",
        name: "Costco Wholesale E Bayamon Warehouse",
        address: "125 CALLE A, BAYAMON, PR 00959-1900",
        addressUrl: "https://maps.app.goo.gl/ofsAF4q1WRwmuhi57",
        state: "PR",
        coordinates: [-66.13867967134445, 18.385027409810633],
    },
    {
        id: "8",
        name: "Costco Wholesale W Bayamon Warehouse",
        address: "PR-2, KM 15.5, BAYAMON, PR 00959-5208",
        addressUrl: "https://maps.app.goo.gl/uob99zrBd5oB4Kg28",
        state: "PR",
        coordinates: [-66.19429127216428, 18.40496640523692],
    },
    {
        id: "9",
        name: "Costco Wholesale Hawaii Kai Warehouse",
        address: "333 A KEAHOLE STREET, HONOLULU, HI 96825-3406",
        addressUrl: "https://maps.app.goo.gl/6c4PvtV3vov3FpFz7",
        state: "HI",
        coordinates: [-157.71009654904228, 21.284009286363464],
    },
    {
        id: "10",
        name: "Costco Wholesale Iwilei Warehouse",
        address: "525 ALAKAWA ST, HONOLULU, HI 96817-5764",
        addressUrl: "https://maps.app.goo.gl/VgJAEgr3gzS4ZMYe6",
        state: "HI",
        coordinates: [-157.87136685557445, 21.319043960111692],
    },
    {
        id: "11",
        name: "Costco Wholesale Kapolei Warehouse",
        address: "4589 KAPOLEI PKWY, KAPOLEI, HI 96707-1879",
        addressUrl: "https://maps.app.goo.gl/f7E36AJxB84Vyevw6",
        state: "HI",
        coordinates: [-158.08759812343212, 21.32678415125034],
    },
    {
        id: "12",
        name: "Costco Wholesale Kauai Warehouse",
        address: "4300 NUHOU ST., LIHUE, HI 96766-8002",
        addressUrl: "https://maps.app.goo.gl/Ww1gTDQoNRBbzNeu8",
        state: "HI",
        coordinates: [-159.37957221736016, 21.967033053133957],
    },
    {
        id: "13",
        name: "Costco Wholesale Kona Warehouse",
        address: "73-5600 MAIAU ST, KAILUA KONA, HI 96740-2630",
        addressUrl: "https://maps.app.goo.gl/Rnt9r1d68QqLniXD7",
        state: "HI",
        coordinates: [-156.01643479530446, 19.685009932925674],
    },
    {
        id: "14",
        name: "Costco Wholesale Maui Warehouse",
        address: "540 HALEAKALA HWY, KAHULUI, HI 96732-2302",
        addressUrl: "https://maps.app.goo.gl/8o6AwGGrcYvPNWGt5",
        state: "HI",
        coordinates: [-156.4507510477786, 20.887271337449594],
    },
    {
        id: "15",
        name: "Costco Wholesale Waipio Warehouse",
        address: "94-1231 KA UKA BLVD, WAIPAHU, HI 96797-4495",
        addressUrl: "https://maps.app.goo.gl/L9rcvJks1f3VjDWX7",
        state: "HI",
        coordinates: [-158.00004740061846, 21.426623796267293],
    },
    {
        id: "16",
        name: "Costco Wholesale Allen Warehouse",
        address: "1067 SH 121, ALLEN, TX 75013-6025",
        addressUrl: "https://maps.app.goo.gl/GMpPQWj2JcCt5Ciw9",
        state: "TX",
        coordinates: [-96.68876907992126, 33.13864826276704],
    },
    {
        id: "17",
        name: "Costco Wholesale Arlington Warehouse",
        address: "600 W ARBROOK BLVD, ARLINGTON, TX 76014-3702",
        addressUrl: "https://maps.app.goo.gl/peqikvWPZ3PZ37qs6",
        state: "TX",
        coordinates: [-97.11241308973099, 32.68328821470767],
    },
    {
        id: "18",
        name: "Costco Wholesale Austin Warehouse",
        address: "10401 RESEARCH BLVD, AUSTIN, TX 78759-5712",
        addressUrl: "https://maps.app.goo.gl/KuaXVjYUpN1AW6Cv8",
        state: "TX",
        coordinates: [-97.74380841277564, 30.396811465548023],
    },
    {
        id: "19",
        name: "Costco Wholesale Bunker Hill Warehouse",
        address: "1150 BUNKER HILL RD, HOUSTON, TX 77055-6208",
        addressUrl: "https://maps.app.goo.gl/LZ6fYgB9XRqWsj1y7",
        state: "TX",
        coordinates: [-95.53041361341423, 29.78804605123992],
    },
    {
        id: "20",
        name: "Costco Wholesale Cedar Park TX Warehouse",
        address: "4601 183A TOLL RD, CEDAR PARK, TX 78613-6310",
        addressUrl: "https://maps.app.goo.gl/wUuXcJjno1gNC8zi6",
        state: "TX",
        coordinates: [-97.81960588018724, 30.527678309864612],
    },
    {
        id: "21",
        name: "Costco Wholesale College Station Warehouse",
        address: "4321 STATE HWY 6 SOUTH, COLLEGE STATION, TX 77845",
        addressUrl: "https://maps.app.goo.gl/FrDKPpcQ1w4TyYGf9",
        state: "TX",
        coordinates: [-96.26336476945636, 30.567179235742685],
    },
    {
        id: "22",
        name: "Costco Wholesale Cypress TX Warehouse",
        address: "26960 NW FREEWAY, CYPRESS, TX 77433-4934",
        addressUrl: "https://maps.app.goo.gl/2qF5Y2CeHuoUknZp6",
        state: "TX",
        coordinates: [-95.71226734107994, 29.979375148497162],
    },
    {
        id: "23",
        name: "Costco Wholesale Dallas Warehouse",
        address: "8055 CHURCHILL WAY, DALLAS, TX 75251-2149",
        addressUrl: "https://maps.app.goo.gl/FdEhkX9HPEnYX1Cb6",
        state: "TX",
        coordinates: [-96.768350257191, 32.919602192062165],
    },
    {
        id: "24",
        name: "Costco Wholesale Duncanville Warehouse",
        address: "250 W HIGHWAY 67, DUNCANVILLE, TX 75137-4415",
        addressUrl: "https://maps.app.goo.gl/Qj4zH83N7u6AaLL4A",
        state: "TX",
        coordinates: [-96.90956217831439, 32.62138481561214],
    },
    {
        id: "25",
        name: "Costco Wholesale E Plano Warehouse",
        address: "3800 N CENTRAL EXPY, PLANO, TX 75074-2221",
        addressUrl: "https://maps.app.goo.gl/btXDPrgG5uTKxhZ47",
        state: "TX",
        coordinates: [-96.69975850259222, 33.0445405045809],
    },
    {
        id: "26",
        name: "Costco Wholesale El Paso Warehouse",
        address: "6101 GATEWAY BLVD W STE 1, EL PASO, TX 79925-3416",
        addressUrl: "https://maps.app.goo.gl/5vCQHUuvXvXDz4pT8",
        state: "TX",
        coordinates: [-106.41060471277511, 31.78401922576419],
    },
    {
        id: "27",
        name: "Costco Wholesale Fort Worth Warehouse",
        address: "5300 OVERTON RIDGE BLVD, FORT WORTH, TX 76132-3301",
        addressUrl: "https://maps.app.goo.gl/UQEzyEUZv13ZCpVW8",
        state: "TX",
        coordinates: [-97.40871921986263, 32.67768914707628],
    },
    {
        id: "28",
        name: "Costco Wholesale Frisco Warehouse",
        address: "11220 DALLAS PKWY, FRISCO, TX 75033-4102",
        addressUrl: "https://maps.app.goo.gl/gSWiWUgSdAvszDBx6",
        state: "TX",
        coordinates: [-96.83691444147956, 33.171929429459276],
    },
    {
        id: "29",
        name: "Costco Wholesale Galleria Warehouse",
        address: "3836 RICHMOND AVE, HOUSTON, TX 77027-5802",
        addressUrl: "https://maps.app.goo.gl/1DPYk1wmn2uqsCLu7",
        state: "TX",
        coordinates: [-95.43970385432749, 29.734107371833293],
    },
    {
        id: "30",
        name: "Costco Wholesale Georgetown Warehouse",
        address: "2201A N IH 35, GEORGETOWN, TX 78628",
        addressUrl: "https://maps.app.goo.gl/TEYFFcFgQyXC5HBz7",
        state: "TX",
        coordinates: [-97.6635595191698, 30.67795522773879],
    },
    {
        id: "31",
        name: "Costco Wholesale Humble Warehouse",
        address: "21802 TOWNSEN BLVD W., HUMBLE, TX 77338-1594",
        addressUrl: "https://maps.app.goo.gl/cdBXGTyhe976BaAK8",
        state: "TX",
        coordinates: [-95.26648579035935, 30.022459051291705],
    },
    {
        id: "32",
        name: "Costco Wholesale Kyle Warehouse",
        address: "19086 IH 35, KYLE, TX 78640-3210",
        addressUrl: "https://maps.app.goo.gl/2dTHEoe7oZLA9wMm7",
        state: "TX",
        coordinates: [-97.85033668473281, 30.03188147561605],
    },
    {
        id: "33",
        name: "Costco Wholesale Lewisville Warehouse",
        address: "851 STATE HIGHWAY 121 BYP, LEWISVILLE, TX 75067-4158",
        addressUrl: "https://maps.app.goo.gl/z21QSLxn2XTYShnbA",
        state: "TX",
        coordinates: [-96.96364904397076, 32.99843284945223],
    },
    {
        id: "34",
        name: "Costco Wholesale Lubbock TX Warehouse",
        address: "6020 34TH ST, LUBBOCK, TX 79407-3102",
        addressUrl: "https://maps.app.goo.gl/WJ61rP93rkicvrh67",
        state: "TX",
        coordinates: [-101.94726406327025, 33.56436795531391],
    },
    {
        id: "35",
        name: "Costco Wholesale McKinney Warehouse",
        address: "3650 W UNIVERSITY DR, MCKINNEY, TX 75071-2934",
        addressUrl: "https://maps.app.goo.gl/kgVtee81EWecF4uc9",
        state: "TX",
        coordinates: [-96.6595238595161, 33.219417478292506],
    },
    {
        id: "36",
        name: "Costco Wholesale Midland TX Warehouse",
        address: "1901 KIRKLAND DRIVE, MIDLAND, TX 79707-2035",
        addressUrl: "https://maps.app.goo.gl/oyrVBpx3uLVW9S8S7",
        state: "TX",
        coordinates: [-102.17657648216603, 31.993910732329187],
    },
    {
        id: "37",
        name: "Costco Wholesale N Fort Worth Warehouse",
        address: "8900 TEHAMA RIDGE PKWY, FORT WORTH, TX 76177-2004",
        addressUrl: "https://maps.app.goo.gl/iiCuF9V4n4qr6LC88",
        state: "TX",
        coordinates: [-97.32021050906035, 32.901112094211655],
    },
    {
        id: "38",
        name: "Costco Wholesale NW San Antonio Warehouse",
        address: "5611 UTSA BLVD, SAN ANTONIO, TX 78249-1619",
        addressUrl: "https://maps.app.goo.gl/NVqTxgtedLB5jo6H7",
        state: "TX",
        coordinates: [-98.59756041699602, 29.576096180085322],
    },
    {
        id: "39",
        name: "Costco Wholesale Pearland Warehouse",
        address: "3500 BUSINESS CENTER DRIVE, PEARLAND, TX 77584-1952",
        addressUrl: "https://maps.app.goo.gl/vita3fnsNqdukk9w5",
        state: "TX",
        coordinates: [-95.39086801300047, 29.544340738653474],
    },
    {
        id: "40",
        name: "Costco Wholesale Pflugerville Warehouse",
        address: "1901 KELLY LN, PFLUGERVILLE, TX 78660",
        addressUrl: "https://maps.app.goo.gl/mtBhH45ZpbRSivS46",
        state: "TX",
        coordinates: [-97.59151545752347, 30.46969795673114],
    },
    {
        id: "41",
        name: "Costco Wholesale Pharr Warehouse",
        address: "1501 W KELLY AVE, PHARR, TX 78577-5031",
        addressUrl: "https://maps.app.goo.gl/MTucQjpSDV7jGkjWA",
        state: "TX",
        coordinates: [-98.20240787843949, 26.192840491311077],
    },
    {
        id: "42",
        name: "Costco Wholesale Prosper Warehouse",
        address: "5620 W UNIVERSITY DRIVE, PROSPER, TX 75078-3830",
        addressUrl: "https://maps.app.goo.gl/WQtwwh2qjfXtsTks5",
        state: "TX",
        coordinates: [-96.89528412693369, 33.22198258820916],
    },
    {
        id: "43",
        name: "Costco Wholesale Richmond TX Warehouse",
        address: "11125 W GRAND PKWY S, RICHMOND, TX 77407-0000",
        addressUrl: "https://maps.app.goo.gl/oYQgUpU7zSxMrVwx6",
        state: "TX",
        coordinates: [-95.70520702558733, 29.64838591886758],
    },
    {
        id: "44",
        name: "Costco Wholesale Rockwall Warehouse",
        address: "1225 STATE HIGHWAY 276, ROCKWALL, TX 75032-9376",
        addressUrl: "https://maps.app.goo.gl/d7VRfk9ZGniNKe2V6",
        state: "TX",
        coordinates: [-96.44567822999201, 32.90806699030771],
    },
    {
        id: "45",
        name: "Costco Wholesale S Austin Warehouse",
        address: "4301 W WILLIAM CANNON DR BLDG A STE 100, AUSTIN, TX 78749-1499",
        addressUrl: "https://maps.app.goo.gl/WZMwghJB8hWD4rtx7",
        state: "TX",
        coordinates: [-97.84251450329467, 30.219053958317765],
    },
    {
        id: "46",
        name: "Costco Wholesale Selma Warehouse",
        address: "15330 IH-35 NORTH, SELMA, TX 78154-3814",
        addressUrl: "https://maps.app.goo.gl/coZQcGGTDx4k5TcEA",
        state: "TX",
        coordinates: [-98.31827417888427, 29.576532755850188],
    },
    {
        id: "47",
        name: "Costco Wholesale Sonterra Park Warehouse",
        address: "1201 N LOOP 1604 E, SAN ANTONIO, TX 78232-1322",
        addressUrl: "https://maps.app.goo.gl/WtCYibBi2x7BXHSx7",
        state: "TX",
        coordinates: [-98.47493381818249, 29.611743702664842],
    },
    {
        id: "48",
        name: "Costco Wholesale Southlake Warehouse",
        address: "2601 E STATE HIGHWAY 114, SOUTHLAKE, TX 76092-6668",
        addressUrl: "https://maps.app.goo.gl/Zy4BwCHUYND4C27v6",
        state: "TX",
        coordinates: [-97.11138382909807, 32.94173698927788],
    },
    {
        id: "49",
        name: "Costco Wholesale Sugar Land Warehouse",
        address: "17520 SOUTHWEST FWY, SUGAR LAND, TX 77479-2359",
        addressUrl: "https://maps.app.goo.gl/f5GTyXMUiRPTUsrj7",
        state: "TX",
        coordinates: [-95.64393298667383, 29.585553423967344],
    },
    {
        id: "50",
        name: "Costco Wholesale The Woodlands Warehouse",
        address: "8185 HIGHWAY 242, CONROE, TX 77385-4365",
        addressUrl: "https://maps.app.goo.gl/StFK6u7BZccjWj4x7",
        state: "TX",
        coordinates: [-95.45317737575543, 30.20875157122116],
    },
    {
        id: "51",
        name: "Costco Wholesale Tomball Warehouse",
        address: "27000 TOMBALL PKWY, TOMBALL, TX 77375-3451",
        addressUrl: "https://maps.app.goo.gl/SAVukTd3pTEKtGzE9",
        state: "TX",
        coordinates: [-95.62190867062193, 30.06917380066388],
    },
    {
        id: "52",
        name: "Costco Wholesale W Katy Warehouse",
        address: "23645 KATY FREEWAY, KATY, TX 77494-7221",
        addressUrl: "https://maps.app.goo.gl/BsuwceNZW9djSogk7",
        state: "TX",
        coordinates: [-95.78109552528254, 29.782894742620027],
    },
    {
        id: "53",
        name: "Costco Wholesale W Plano Warehouse",
        address: "1701 DALLAS PKWY, PLANO, TX 75093-4580",
        addressUrl: "https://maps.app.goo.gl/9KEn6HM26YYMXRpK9",
        state: "TX",
        coordinates: [-96.83141935941156, 33.02391211294608],
    },
    {
        id: "54",
        name: "Costco Wholesale W San Antonio Warehouse",
        address: "191 W LOOP 1604 S, SAN ANTONIO, TX 78245-4191",
        addressUrl: "https://maps.app.goo.gl/aQXMFhhTnJ9qc6ji6",
        state: "TX",
        coordinates: [-98.71489102678153, 29.432189839285822],
    },
    {
        id: "55",
        name: "Costco Wholesale Weatherford Warehouse",
        address: "310 CENTER POINT ROAD, WEATHERFORD, TX 76087-4940",
        addressUrl: "https://maps.app.goo.gl/QnFZLkJSjerPAcin9",
        state: "TX",
        coordinates: [-97.7312942017513, 32.74955645401563],
    },
    {
        id: "56",
        name: "Costco Wholesale Webster Warehouse",
        address: "1310 JASMINE AVE, WEBSTER, TX 77598-3210",
        addressUrl: "https://maps.app.goo.gl/8sbjWic6uLst8ysv6",
        state: "TX",
        coordinates: [-95.14049566801674, 29.53326843893478],
    },
    {
        id: "57",
        name: "Costco Wholesale Willowbrook Warehouse",
        address: "12405 N GESSNER RD, HOUSTON, TX 77064-1170",
        addressUrl: "https://maps.app.goo.gl/wUBwBTC4Awko9yKE8",
        state: "TX",
        coordinates: [-95.54826970403616, 29.95474013396052],
    },
    {
        id: "58",
        name: "Costco Wholesale Alhambra Warehouse",
        address: "2207 W COMMONWEALTH AVE, ALHAMBRA, CA 91803-1302",
        addressUrl: "https://maps.app.goo.gl/eRQUo7gLHptxaTQY7",
        state: "CA",
        coordinates: [-118.14868045179998, 34.08992152136544],
    },
    {
        id: "59",
        name: "Costco Wholesale Azusa Warehouse",
        address: "1220 W FOOTHILL BLVD, AZUSA, CA 91702-2819",
        addressUrl: "https://maps.app.goo.gl/FLzm4b9ZLHGzj32Y8",
        state: "CA",
        coordinates: [-117.925554752904, 34.13193821015575],
    },
    {
        id: "60",
        name: "Costco Wholesale Burbank Warehouse",
        address: "1051 W BURBANK BLVD, BURBANK, CA 91506-1421",
        addressUrl: "https://maps.app.goo.gl/dXy6tNM55hGfhpSY7",
        state: "CA",
        coordinates: [-118.32384644500151, 34.18556048518915],
    },
    {
        id: "61",
        name: "Costco Wholesale City Of Industry Warehouse",
        address: "17550 CASTLETON ST, CITY OF INDUSTRY, CA 91748-1701",
        addressUrl: "https://maps.app.goo.gl/hUvW56ES6FwaH8fG7",
        state: "CA",
        coordinates: [-117.92214836576413, 33.99450353267216],
    },
    {
        id: "62",
        name: "Costco Wholesale Culver City Warehouse",
        address: "13463 WASHINGTON BLVD, MARINA DEL REY, CA 90292-5658",
        addressUrl: "https://maps.app.goo.gl/FWCJ43SyxGc8c2beA",
        state: "CA",
        coordinates: [-118.44714354551365, 33.99320317044271],
    },
    {
        id: "63",
        name: "Costco Wholesale Hawthorne Warehouse",
        address: "14501 HINDRY AVENUE, HAWTHORNE, CA 90250-6748",
        addressUrl: "https://maps.app.goo.gl/nGvMK24o98RX97Ng8",
        state: "CA",
        coordinates: [-118.37377347804947, 33.89988909861752],
    },
    {
        id: "64",
        name: "Costco Wholesale Inglewood Warehouse",
        address: "3560 W CENTURY BLVD, INGLEWOOD, CA 90303-1201",
        addressUrl: "https://maps.app.goo.gl/rEh35U29qNQK7iBx6",
        state: "CA",
        coordinates: [-118.33341755925156, 33.942838294855896],
    },
    {
        id: "65",
        name: "Costco Wholesale Los Feliz Warehouse",
        address: "2901 LOS FELIZ BLVD, LOS ANGELES, CA 90039-1502",
        addressUrl: "https://maps.app.goo.gl/8gki6QBf1zr7NEQq6",
        state: "CA",
        coordinates: [-118.26381888586737, 34.12918457419922],
    },
    {
        id: "66",
        name: "Costco Wholesale Monterey Park Warehouse",
        address: "2000 MARKET PLACE DR, MONTEREY PARK, CA 91755-7402",
        addressUrl: "https://maps.app.goo.gl/Um7sWZgrTXCJwBWV7",
        state: "CA",
        coordinates: [-118.10413829698922, 34.03713970435903],
    },
    {
        id: "67",
        name: "Costco Wholesale Northridge Warehouse",
        address: "8810 TAMPA AVE, NORTHRIDGE, CA 91324-3519",
        addressUrl: "https://maps.app.goo.gl/QZroyx8ZTKgzgVtb8",
        state: "CA",
        coordinates: [-118.55078397434181, 34.23081389551239],
    },
    {
        id: "68",
        name: "Costco Wholesale Norwalk CA Warehouse",
        address: "12324 HOXIE AVE, NORWALK, CA 90650-2211",
        addressUrl: "https://maps.app.goo.gl/XeEzbGopXg5sZnN39",
        state: "CA",
        coordinates: [-118.10269962962097, 33.91957738301932],
    },
    {
        id: "69",
        name: "Costco Wholesale Pacoima Warehouse",
        address: "13550 PAXTON ST, PACOIMA, CA 91331-2352",
        addressUrl: "https://maps.app.goo.gl/KeYJ3TZbpRUsfVoU7",
        state: "CA",
        coordinates: [-118.42673004365629, 34.27196273312923],
    },
    {
        id: "70",
        name: "Costco Wholesale Santa Clarita Warehouse",
        address: "18649 VIA PRINCESSA, SANTA CLARITA, CA 91387-4935",
        addressUrl: "https://maps.app.goo.gl/3m1JAa7FPxQRvM519",
        state: "CA",
        coordinates: [-118.4617735973861, 34.404627219033145],
    },
    {
        id: "71",
        name: "Costco Wholesale Signal Hill Warehouse",
        address: "2200 E WILLOW ST, SIGNAL HILL, CA 90755-2132",
        addressUrl: "https://maps.app.goo.gl/B7monFFvEZqDPGqf9",
        state: "CA",
        coordinates: [-118.1647617412051, 33.80330363240889],
    },
    {
        id: "72",
        name: "Costco Wholesale Torrance Warehouse",
        address: "2640 LOMITA BLVD, TORRANCE, CA 90505-5214",
        addressUrl: "https://maps.app.goo.gl/nxKcWGHRrUmypoce9",
        state: "CA",
        coordinates: [-118.33361574367065, 33.806684006490215],
    },
    {
        id: "73",
        name: "Costco Wholesale Van Nuys Warehouse",
        address: "6100 SEPULVEDA BLVD, VAN NUYS, CA 91411-2503",
        addressUrl: "https://maps.app.goo.gl/PEuPLxEk2ji1ZDMh8",
        state: "CA",
        coordinates: [-118.46358264550786, 34.18145175782822],
    },
    {
        id: "74",
        name: "Costco Wholesale Westlake Village Warehouse",
        address: "5700 LINDERO CANYON RD, WESTLAKE VILLAGE, CA 91362-4063",
        addressUrl: "https://maps.app.goo.gl/ZbHjGvtWyXN7zi6c7",
        state: "CA",
        coordinates: [-118.79722672277194, 34.152093249443546],
    },
    {
        id: "75",
        name: "Costco Wholesale Woodland Hills Warehouse",
        address: "21800 VICTORY BLVD, WOODLAND HILLS, CA 91367-2227",
        addressUrl: "https://maps.app.goo.gl/KGVhjnavgM2ECEYa6",
        state: "CA",
        coordinates: [-118.60330316417593, 34.18680586743871],
    },
];
